import React from 'react';
import {
    IconButton, RaisedButton, Table, TableBody, TableHeader, TableHeaderColumn, TableRow,
    TableRowColumn
} from "material-ui";
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import PropTypes from 'prop-types';
import WebhookDialog from "./WebhookDialog";
import queries from "../../graphql/queries";
import OverlayController from "../overlay/OverlayController";
import utils from "../../utils/utils";
import { compose } from 'react-apollo';
import _ from 'lodash';
import './Webhooks.css';


export default compose(
    queries.projectQueryHocWithName('projectData'),
)(class Webhooks extends React.Component {

    static propTypes = {
        projectData: PropTypes.object.isRequired,
        params: PropTypes.shape({
            projectId: PropTypes.string.isRequired
        }).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.onAddWebhookButtonClick = this.onAddWebhookButtonClick.bind(this);
        this.onEditWebhookClick = this.onEditWebhookClick.bind(this);

        this.state = {};
    }

    onAddWebhookButtonClick() {
        OverlayController.showOverlay({
            component: <WebhookDialog project={this.props.projectData.project}/>
        });
    }

    onEditWebhookClick(event) {
        let webhookId = utils.getValueAtPathOfClosestParent(event.currentTarget, 'dataset.webhookId');
        let webhook = _.find(this.props.projectData.project.webhooks, {id: webhookId});
        OverlayController.showOverlay({
            component: <WebhookDialog project={this.props.projectData.project} webhook={webhook} />
        });
    }

    renderWebhookList() {
        let statesById = _.keyBy(this.props.projectData.project.states, 'id');
        return (
            <Table selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn className="editColumn"/>
                        <TableHeaderColumn>Enabled</TableHeaderColumn>
                        <TableHeaderColumn>Status</TableHeaderColumn>
                        <TableHeaderColumn>Callback Url</TableHeaderColumn>
                        <TableHeaderColumn>Triggers</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {this.props.projectData.project.webhooks.map(webhook => (
                        <TableRow key={webhook.id} data-webhook-id={webhook.id} className="pluginRow">
                            <TableRowColumn className="editColumn"><IconButton className="editColumnButton" onTouchTap={this.onEditWebhookClick}><EditIcon/></IconButton></TableRowColumn>
                            <TableRowColumn>{webhook.enabled ? 'enabled' : 'disabled'}</TableRowColumn>
                            <TableRowColumn>{webhook.status}</TableRowColumn>
                            <TableRowColumn>{webhook.callbackUrl}</TableRowColumn>
                            <TableRowColumn>{webhook.triggers.map(trigger => `${trigger.name}:${statesById[trigger.stateId].name}`).join(', ')}</TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    render() {
        return (
            <div className="webhooksContainer">
                <h2>Webhooks</h2>
                <RaisedButton className="addPluginButton" label="Add Webhook" primary={true} onTouchTap={this.onAddWebhookButtonClick}/>
                {utils.renderGraphQLStatusOrNull(this.props.projectData) || this.renderWebhookList()}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/webhooks/Webhooks.js